import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'
import _imports_1 from '@/assets/img/check.svg'
import _imports_2 from '@/assets/img/exclamation-triangle-fill-yellow.svg'


const _withScopeId = n => (_pushScopeId("data-v-64590740"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "d-flex align-items-center mb-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "table table-striped"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_12 = { class: "d-block mt-1" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "text-center mt-4 pt-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_19 = { class: "fw_700" }
const _hoisted_20 = { class: "text-center mt-5" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Select a configuration to copy",
          text: "Select a configuration to copy"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layerList.filter(x => x.layerName != _ctx.selectedLayer.layerName), (layer, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["layerToSelect", { 'selected': _ctx.selectedLayersToCopyInto == layer.layerName }]),
          onClick: ($event: any) => (_ctx.selectedLayersToCopyInto = layer.layerName),
          key: index
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(["sameAsCheckbox me-2", { 'active': _ctx.selectedLayersToCopyInto == layer.layerName }])
            }, null, 2),
            _createElementVNode("strong", null, _toDisplayString(layer.layerName), 1)
          ]),
          _createVNode(_component_localized_text, {
            type: "h5",
            localizedKey: "Transportation",
            text: "Transportation",
            class: "pt-2"
          }),
          _hoisted_9,
          (Object.keys(_ctx.groupedbyLayer(layer.layerName)).length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_11,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rawMaterials(layer.layerName), (obj) => {
                      return (_openBlock(), _createElementBlock("th", {
                        class: "text-center",
                        key: obj.identifier
                      }, [
                        _createTextVNode(_toDisplayString(obj.rawMaterial.text) + " ", 1),
                        _createElementVNode("label", _hoisted_12, _toDisplayString(obj.productionCountry.text), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedbyLayer(layer.layerName), (rawMaterialsGroup, name) => {
                    return (_openBlock(), _createElementBlock("tr", { key: name }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("strong", null, _toDisplayString(name), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rawMaterials(layer.layerName), (material) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "text-center",
                          key: material.identifier
                        }, [
                          (rawMaterialsGroup[material.identifier])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                            : (_openBlock(), _createElementBlock("span", _hoisted_16, "--"))
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_7))
      }), 128)),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_localized_text, {
          localizedKey: "Processes will be copied from the selected layer to this one:",
          text: "Processes will be copied from the selected layer to this one:",
          type: "p",
          class: "mt-2 mb-1 w-75 mx-auto"
        }),
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.selectedLayer.layerName), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Confirm",
            text: "Confirm"
          })
        ], 8, _hoisted_21)
      ])
    ])
  ]))
}